/* mwy v2 */


/* =========================
   MWY – site scripts (clean drop-in)
   ========================= */

(() => {
  'use strict';

  /* -------------------------
   * Config
   * ------------------------- */
  var FREE_SHIPPING_THRESHOLD = 75.0;
  var MOBILE_MAX = 990; // Motion mobile breakpoint
  var IDS = {
    freeMsg: 'free-shipping-message',
    freeMsgDrawer: 'free-shipping-message-drawer',
    usBanner: 'us-shipping-banner',
    navDrawer: 'NavDrawer',
  };
  /* -------------------------
   * Helpers
   * ------------------------- */
  var isUS = () => typeof Shopify !== 'undefined' && Shopify.country === 'US';
  var $ = (sel, root = document) => root.querySelector(sel);
  var $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  var fetchCart = () => fetch('/cart.js').then((r) => r.json());

  /* -------------------------
   * Free shipping messages
   * ------------------------- */
  async function updateFreeShippingMessage() {
    var msgEl = document.getElementById(IDS.freeMsg);
    var bannerEl = document.getElementById(IDS.usBanner);
    if (!msgEl && !bannerEl) return; // nothing to do

    // Non-US: hide all shipping promos
    if (!isUS()) {
      if (msgEl) msgEl.style.display = 'none';
      if (bannerEl) bannerEl.style.display = 'none';
      return;
    }

    try {
      var cart = await fetchCart();
      var subtotal = (cart.total_price || 0) / 100;
      var diff = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);

      if (cart.item_count > 0) {
        // Hide default banner; show dynamic message
        if (bannerEl) bannerEl.style.display = 'none';
        if (msgEl) {
          msgEl.style.display = 'block';
          if (subtotal >= FREE_SHIPPING_THRESHOLD) {
            msgEl.innerHTML = '✅ You Qualified for <em>FREE</em> shipping!';
          } else {
            msgEl.innerHTML = `📦 You're <strong>$${diff}</strong> away from <em>FREE</em> shipping!`;
          }
        }
      } else {
        // Empty cart: show default banner; hide dynamic message
        if (bannerEl) bannerEl.style.display = 'block';
        if (msgEl) msgEl.style.display = 'none';
      }
    } catch (err) {
      console.error('Free shipping (cart page) error:', err);
    }
  }

  async function updateFreeShippingMessageDrawer() {
    var el = document.getElementById(IDS.freeMsgDrawer);
    if (!el) return;

    if (!isUS()) {
      el.style.display = 'none';
      return;
    }

    el.style.display = 'block';
    try {
      var cart = await fetchCart();
      var subtotal = (cart.total_price || 0) / 100;
      var diff = Math.max(0, FREE_SHIPPING_THRESHOLD - subtotal).toFixed(2);

      if (subtotal >= FREE_SHIPPING_THRESHOLD) {
        el.innerHTML = '✅ You Qualified for <em>FREE</em> shipping!';
      } else {
        el.innerHTML = `📦 You're <strong>$${diff}</strong> away from <em>FREE</em> shipping!`;
      }
    } catch (err) {
      console.error('Free shipping (drawer) error:', err);
    }
  }

  
  /* -------------------------
   * Cart-related event wiring
   * ------------------------- */
  function wireCartEvents() {
    // Initial load
    updateFreeShippingMessage();
    updateFreeShippingMessageDrawer();

    // After +/- quantity clicks
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.qty__adjust')) return;
      setTimeout(() => {
        updateFreeShippingMessage();
        updateFreeShippingMessageDrawer();
      }, 500);
    });

    // When any "open drawer" control is clicked, refresh the drawer message
    document.addEventListener('click', (e) => {
      var opener = e.target.closest('[data-action="open-drawer"], [aria-controls="CartDrawer"], [data-drawer-id="CartDrawer"]');
      if (!opener) return;
      // Refresh after drawer animation
      setTimeout(updateFreeShippingMessageDrawer, 500);
    });

    // After product is added via AJAX or on cart form submit
    document.addEventListener('submit', (e) => {
      var addForm = e.target.closest('form[action^="/cart/add"]');
      if (addForm) {
        setTimeout(() => {
          updateFreeShippingMessage();
          updateFreeShippingMessageDrawer();
        }, 800);
      }

      var cartForm = e.target.closest('form[action="/cart"]');
      if (cartForm) {
        setTimeout(() => {
          updateFreeShippingMessage();
          updateFreeShippingMessageDrawer();
        }, 800);
      }
    });

    // Watch subtotal DOM updates on the cart page
    var subtotalEl = document.querySelector('[data-subtotal]');
    if (subtotalEl) {
      var observer = new MutationObserver(() => {
        updateFreeShippingMessage();
        updateFreeShippingMessageDrawer();
      });
      observer.observe(subtotalEl, { characterData: true, childList: true, subtree: true });
    }
  }

  /* -------------------------
   * Init
   * ------------------------- */
  function init() {
    wireCartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* -------------------------
 * MOBILE NAV (Motion) — auto-expand first level when #NavDrawer opens
 * Self-contained; does not depend on the code above.
 * ------------------------- */
(() => {
  var MOBILE_MAX = 990;                // adjust if your mobile breakpoint differs
  var NAV_ID = 'NavDrawer';
  var $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function isVisible(el) {
    if (!el) return false;
    if (el.getAttribute('aria-hidden') === 'true') return false;
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function expandFirstLevel(drawer) {
    if (!drawer || window.innerWidth > MOBILE_MAX) return;
    var toggles = $$('.mobile-nav > li .collapsible-trigger[aria-controls^="Linklist-"]', drawer);
    toggles.forEach(btn => {
      if (btn.getAttribute('aria-expanded') !== 'true') btn.click(); // use theme's own handler
    });
    drawer.dataset._autoExpanded = '1';
  }

  function onPossibleOpen() {
    var drawer = document.getElementById(NAV_ID);
    if (!drawer) return;
    if (isVisible(drawer) && drawer.dataset._autoExpanded !== '1') expandFirstLevel(drawer);
    if (!isVisible(drawer)) delete drawer.dataset._autoExpanded;
  }

  function init() {
    var drawer = document.getElementById(NAV_ID);
    if (!drawer) return;

    // Try immediately (theme editor cases)
    onPossibleOpen();

    // Observe drawer attribute/class changes
    var mo = new MutationObserver(onPossibleOpen);
    mo.observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });

    // Some builds toggle classes on <html>
    var moRoot = new MutationObserver(onPossibleOpen);
    moRoot.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    // Also react when open buttons are clicked
    document.addEventListener('click', (e) => {
      if (e.target.closest('[aria-controls="NavDrawer"], [data-drawer-id="NavDrawer"], [href="#NavDrawer"]')) {
        setTimeout(onPossibleOpen, 50);
      }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();

/* =====================================================
   Footer section headings
   — Menu columns: reads title from data-mwy-menu-title (set in footer.liquid)
   — Newsletter column: reads from collapsible trigger button text
   ===================================================== */
(function() {
  function _mwyFooterHeadings() {
    // Menu columns: read Shopify menu title from data attribute
    var menus = document.querySelectorAll('footer .grid__item[data-mwy-menu-title]');
    menus.forEach(function(col) {
      if (col.querySelector('.mwy-menu-heading')) return;
      var title = col.getAttribute('data-mwy-menu-title');
      if (!title) return;
      var h = document.createElement('h2');
      h.className = 'footer__title mwy-menu-heading';
      h.textContent = title;
      col.insertBefore(h, col.firstChild);
    });

    // Newsletter column: use the Shopify-rendered trigger button text
    var newsletter = document.querySelector('footer .grid-newsletter');
    if (newsletter && !newsletter.querySelector('.mwy-menu-heading')) {
      var btn = newsletter.querySelector('.collapsible-trigger-btn');
      var title = btn ? btn.childNodes[0].textContent.trim() : 'Mailing List';
      var h = document.createElement('h2');
      h.className = 'footer__title mwy-menu-heading';
      h.textContent = title;
      newsletter.insertBefore(h, newsletter.firstChild);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _mwyFooterHeadings);
  } else {
    _mwyFooterHeadings();
  }
})();

/* =====================================================
   Newsletter subscribe: success modal
   Replaces inline "Thanks for subscribing" with a
   branded modal overlay.
   ===================================================== */
(function() {
  function _mwySubscribeModal() {
    var successNote = document.querySelector('#newsletter-footer .note--success');
    if (!successNote) return;

    // Hide the inline success message
    successNote.style.display = 'none';

    // Build modal
    var overlay = document.createElement('div');
    overlay.className = 'mwy-subscribe-modal';
    overlay.innerHTML =
      '<div class="mwy-subscribe-modal__card">' +
        '<p class="mwy-subscribe-modal__title">Thank you for joining<br>our mailing list.</p>' +
        '<button class="mwy-subscribe-modal__btn">You’re Welcome</button>' +
      '</div>';
    document.body.appendChild(overlay);

    // Animate in (double rAF ensures transition fires)
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.classList.add('is-open');
      });
    });

    function closeModal() {
      overlay.classList.remove('is-open');
      setTimeout(function() { if (overlay.parentNode) overlay.parentNode.removeChild(overlay); }, 350);
    }

    overlay.querySelector('.mwy-subscribe-modal__btn').addEventListener('click', closeModal);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeModal();
    });
    document.addEventListener('keydown', function onKey(e) {
      if (e.key === 'Escape') { closeModal(); document.removeEventListener('keydown', onKey); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', _mwySubscribeModal);
  } else {
    _mwySubscribeModal();
  }
})();

/* Desktop LIVE dropdown: open on hover instead of click */
(function() {
  if (window.innerWidth < 750) return;
  var details = document.querySelector('.site-nav__details');
  if (!details) return;
  var summary = details.querySelector('summary');
  var closeTimer = null;

  // Prevent click from toggling (only hover should control it)
  summary.addEventListener('click', function(e) {
    e.preventDefault();
  });

  details.addEventListener('mouseenter', function() {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    details.setAttribute('open', '');
  });

  details.addEventListener('mouseleave', function() {
    closeTimer = setTimeout(function() {
      details.removeAttribute('open');
    }, 200);
  });
})();


/* Desktop: hovering the logo also opens the LIVE dropdown */
(function() {
  function initLogoDropdown() {
    var logo = document.querySelector('#LogoContainer');
    var details = document.querySelector('#site-nav-item--1');
    var summary = details ? details.querySelector('summary') : null;
    if (!logo || !details || !summary) return;

    var closeTimer = null;
    var isClosing = false;

    function openDropdown() {
      clearTimeout(closeTimer);
      if (isClosing) {
        isClosing = false;
        details.classList.remove('is-closing');
      }
      details.setAttribute('open', '');
      summary.setAttribute('aria-expanded', 'true');
    }

    function animateClose() {
      if (!details.hasAttribute('open')) return;
      closeTimer = setTimeout(function() {
        isClosing = true;
        details.classList.add('is-closing');
        setTimeout(function() {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
          details.classList.remove('is-closing');
          isClosing = false;
        }, 450);
      }, 150);
    }

    function cancelClose() {
      clearTimeout(closeTimer);
      if (isClosing) {
        isClosing = false;
        details.classList.remove('is-closing');
      }
    }

    logo.addEventListener('mouseenter', openDropdown);
    logo.addEventListener('mouseleave', animateClose);
    details.addEventListener('mouseenter', cancelClose);
    details.addEventListener('mouseleave', animateClose);

    /* Also handle native hover on the summary/LIVE text */
    summary.addEventListener('click', function(e) {
      e.preventDefault();
      if (details.hasAttribute('open') && !isClosing) {
        animateClose();
      } else {
        openDropdown();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLogoDropdown);
  } else {
    initLogoDropdown();
  }
})();

/* Mobile drawer: auto-open LIVE submenu when drawer opens */
(function() {
  function initDrawerObserver() {
    var drawer = document.querySelector('#NavDrawer');
    if (!drawer) return;

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName !== 'class') return;

        if (drawer.classList.contains('drawer--is-open')) {
          setTimeout(function() {
            var trigger = drawer.querySelector('.collapsible-trigger');
            var collapsible = drawer.querySelector('.collapsible-content');
            if (trigger && collapsible && !collapsible.classList.contains('is-open')) {
              trigger.classList.add('is-open');
              collapsible.classList.add('is-open');
              collapsible.style.height = collapsible.scrollHeight + 'px';
              collapsible.style.overflow = 'visible';
              collapsible.setAttribute('aria-hidden', 'false');
              trigger.setAttribute('aria-expanded', 'true');
            }
          }, 300);
        }

        if (!drawer.classList.contains('drawer--is-open')) {
          var trigger = drawer.querySelector('.collapsible-trigger');
          var collapsible = drawer.querySelector('.collapsible-content');
          if (trigger && collapsible) {
            setTimeout(function() {
              trigger.classList.remove('is-open');
              collapsible.classList.remove('is-open');
              collapsible.style.height = '';
              collapsible.style.overflow = '';
              collapsible.setAttribute('aria-hidden', 'true');
              trigger.setAttribute('aria-expanded', 'false');
            }, 500);
          }
        }
      });
    });

    observer.observe(drawer, { attributes: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerObserver);


  } else {
    initDrawerObserver();
  }
})();


(function _mwyAuctionInit() {
  var ATTEMPTS = 0; var MAX = 60;

  function splitBidAmount(el) {
    var amountEl = el.querySelector('#_a-current-bid');
    var num;

    if (amountEl) {
      // After-bid state: AP injects #_a-current-bid + #_a-bids inside the span
      var raw = amountEl.textContent.replace(/\$/g, '').replace(/,/g, '').trim();
      num = raw.split('.')[0].trim();
      if (!num || isNaN(parseInt(num, 10))) return;
      // Style just the amount element, leave #_a-bids untouched
      amountEl.innerHTML = '<span class="mwy-amt"><span class="mwy-cur">$<\/span>' + num + '<\/span>';
      // Hide the 'Current bid: ' label span (we use data-bid-label ::before instead)
      var labelSpan = el.querySelector(':scope > span:not(.mwy-amt)');
      if (labelSpan) labelSpan.style.display = 'none';
    } else {
      // Starting bid state: plain text 'Starting bid: $ 150.00'
      var raw = el.textContent.trim();
      var colonIdx = raw.indexOf(':');
      if (colonIdx > -1) raw = raw.substring(colonIdx + 1).trim();
      raw = raw.replace(/\$/g, '').replace(/,/g, '').trim();
      num = raw.split('.')[0].trim();
      if (!num || isNaN(parseInt(num, 10))) return;
      el.innerHTML = '<span class="mwy-amt"><span class="mwy-cur">$<\/span>' + num + '<\/span>';
    }
  }

  function initLabel(el) {
    var hasCurrent = el.querySelector('#_a-current-bid') !== null;
    var isCurrent = hasCurrent || el.textContent.toLowerCase().indexOf('current') > -1;
    el.setAttribute('data-bid-label', isCurrent ? 'CURRENT BID' : 'STARTING BID');
  }

  var interval = setInterval(function() {
    ATTEMPTS++;
    if (ATTEMPTS > MAX) { clearInterval(interval); return; }
    var visible = document.querySelector('._a-auction-input-container > span._a-current-bid-font:not(._a-hide)');
    if (!visible || visible.textContent.indexOf('$') === -1) return;
    clearInterval(interval);

    var isMobile = window.innerWidth < 750;

    // 1. Placeholder
    var bidInput = document.getElementById('_a-bid-input');
    if (bidInput) bidInput.setAttribute('placeholder', 'Your bid amount');

    // 2. ENTER button
    var bidBtn = document.getElementById('_a-bid-btn');
    if (bidBtn) bidBtn.textContent = 'Enter Bid';

    // 3. Place Auto Bid
    var autoBid = document.getElementById('_a-auto-bid');
    if (autoBid) { var lbl = autoBid.querySelector('b'); if (lbl) lbl.textContent = 'Place Auto Bid'; }

    // 4. Watch This Auction
    var wl = document.getElementById('_a-btn-watchlist');
    if (wl) { var wlT = wl.querySelector('._a-btn-watchlist-text'); if (wlT) wlT.textContent = 'Watch This Auction'; }

    // 5. Bid label + split amount
    initLabel(visible);
    splitBidAmount(visible);

    // 6. Watch for AP updating the span (new bid placed)
    if (!visible._mwyAmtObs) {
      visible._mwyAmtObs = new MutationObserver(function() {
        visible._mwyAmtObs.disconnect();
        initLabel(visible);
        if (!visible.querySelector('.mwy-amt')) splitBidAmount(visible);
        else if (visible.querySelector('#_a-current-bid:not(:has(.mwy-amt))')) splitBidAmount(visible);
        visible._mwyAmtObs.observe(visible, { childList: true, subtree: true });
      });
      visible._mwyAmtObs.observe(visible, { childList: true, subtree: true });
    }

    // 6b. Container observer — catches span replacement when AP processes a new bid
    var bidContainer = visible.parentElement;
    if (bidContainer && !bidContainer._mwyContObs) {
      bidContainer._mwyContObs = new MutationObserver(function() {
        var newVis = bidContainer.querySelector('span._a-current-bid-font:not(._a-hide)');
        if (newVis && !newVis._mwyObsInit) {
          newVis._mwyObsInit = true;
          initLabel(newVis);
          splitBidAmount(newVis);
          if (!newVis._mwyAmtObs) {
            newVis._mwyAmtObs = new MutationObserver(function() {
              newVis._mwyAmtObs.disconnect();
              initLabel(newVis);
              if (!newVis.querySelector('.mwy-amt')) splitBidAmount(newVis);
              else if (newVis.querySelector('#_a-current-bid:not(:has(.mwy-amt))')) splitBidAmount(newVis);
              newVis._mwyAmtObs.observe(newVis, { childList: true, subtree: true });
            });
            newVis._mwyAmtObs.observe(newVis, { childList: true, subtree: true });
          }
        }
      });
      bidContainer._mwyContObs.observe(bidContainer, { childList: true, subtree: true });
    }

    // 7. Hint
    function stripCents(t) { return t.split('.00').join(''); }
    var allDivs = document.querySelectorAll('#_a-auction-inputs-container div');
    var hintEl = null;
    for (var i = 0; i < allDivs.length; i++) { if (allDivs[i].textContent.indexOf('or more') > -1) { hintEl = allDivs[i]; break; } }
    if (hintEl) {
      hintEl.textContent = stripCents(hintEl.textContent);
      hintEl.classList.add('mwy-bid-hint');
      hintEl.style.setProperty('text-align', isMobile ? 'center' : 'left', 'important');
      hintEl.style.setProperty('margin-bottom', '10px', 'important');
      if (!hintEl._mwyDecObs) {
        hintEl._mwyDecObs = new MutationObserver(function() {
          if (hintEl.textContent.indexOf('.00') > -1) hintEl.textContent = stripCents(hintEl.textContent);
        });
        hintEl._mwyDecObs.observe(hintEl, { childList: true, characterData: true, subtree: true });
      }
    }

        // 8. End date
    var endEl = document.getElementById('_a-end-date');
    if (endEl && !endEl.getAttribute('data-date')) {
      var raw = endEl.textContent.trim();
      var isStart = /^start date:/i.test(raw);
      raw = raw.replace(/^(end|start) date:\s*/i, '');
      var dm = raw.match(/\w+,\s+(\w+ \d+,\s*\d{4})\s*[-–]\s*(\d+:\d+):\d+\s*(AM|PM)/i);
      if (dm) {
        endEl.setAttribute('data-date', dm[1] + ' · ' + dm[2] + ' ' + dm[3] + ' ET');
        if (isStart) {
          endEl.setAttribute('data-start-date', dm[1]);
        } else {
          endEl.setAttribute('data-end-date', dm[1]);
        }
      } else if (raw.length > 3) {
        endEl.setAttribute('data-date', raw);
      }
    }

    // 9. Countdown
    function fmtCt(t) { return t.replace(/([0-9]+)h/, '$1 hrs').replace(/([0-9]+)m/, '$1 mins').replace(/([0-9]+)s/, '$1 secs').trim(); }
    var ct = document.getElementById('_a-countdown-timer');
    if (ct) {
      if (ct.textContent.indexOf('h') > -1) ct.textContent = fmtCt(ct.textContent);
      if (!ct._mwyCtObs) {
        ct._mwyCtObs = new MutationObserver(function() {
          var t = ct.textContent.trim();
          if (t.indexOf('h') > -1 && t.indexOf('hrs') === -1) ct.textContent = fmtCt(t);
        });
        ct._mwyCtObs.observe(ct, { childList: true, characterData: true, subtree: true });
      }
    }

  }, 150);


  // ── Custom notice: intercepts AP errors & banners ────────────────────────
  (function initMwyNotice() {

    // Create and insert our notice element after the bid hint
    function getOrCreateNotice() {
      var el = document.querySelector('.mwy-notice');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'mwy-notice';
      var hint = document.querySelector('#_a-auction-inputs-container .mwy-bid-hint');
      if (hint && hint.parentElement) {
        hint.parentElement.insertBefore(el, hint.nextSibling);
      }
      return el;
    }

    // Show notice with given HTML, then auto-fade after 10s
    function showNotice(html, type) {
      if (!html || !html.trim()) return;
      var el = getOrCreateNotice();
      if (el._fadeTimer) clearTimeout(el._fadeTimer);
      el.innerHTML = html;
      el.classList.remove('mwy-notice--error', 'mwy-notice--success');
      el.classList.add(type === 'success' ? 'mwy-notice--success' : 'mwy-notice--error');
      el.style.opacity = '1';
      el.style.display = 'block';
      el._fadeTimer = setTimeout(function() {
        el.style.opacity = '0';
        setTimeout(function() {
          el.style.display = 'none';
          el.style.opacity = '1';
          el._fadeTimer = null;
        }, 850);
      }, 10000);
    }

    // Watch #_a-error-message for when AP removes _a-hide → always an error
    var errDiv = document.querySelector('#_a-error-message');
    var errSpan = document.querySelector('#_a-error-message-span');
    if (errDiv && errSpan) {
      new MutationObserver(function() {
        if (!errDiv.classList.contains('_a-hide') && !errDiv.classList.contains('_a-display-none')) {
          var html = errSpan.innerHTML.trim();
          errDiv.classList.add('_a-hide');
          if (/must\s+(log\s*in|login)|login\s+or\s+create/i.test(html)) { html = '<a href="/account/login">Log in<\/a> to place a bid'; }
             showNotice(html, 'error');
        }
      }).observe(errDiv, { attributes: true, attributeFilter: ['class'] });
    }

    // Watch all AP banner divs; outbid = error, others = success
    var bannerTypes = {
      '_a-banner-div': 'success',
      '_a-banner-div-notification': 'success',
      '_a-banner-div-notification-outbid': 'error',
      '_a-banner-div-notification-alt': 'success'
    };
    Object.keys(bannerTypes).forEach(function(id) {
      var banner = document.getElementById(id);
      if (!banner) return;
      var type = bannerTypes[id];
      new MutationObserver(function() {
        if (!banner.classList.contains('_a-display-none')) {
          var msgEl = banner.querySelector('._a-banner-message, ._a-banner-text-notification');
          var html = msgEl ? msgEl.innerHTML.trim() : '';
          banner.classList.add('_a-display-none');
          if (html) showNotice(html, type);
        }
      }).observe(banner, { attributes: true, attributeFilter: ['class'] });
    });

  })();

})();


// ── Bid Confirm Modal: inject bid amount before display ───────────
(function initConfirmModal() {
  var modal = document.getElementById('_a-auction-modal-bid-confirm');
  if (!modal) return;
  var body = modal.querySelector('._a-modal-body');
  if (!body) return;

  function updateBody() {
    var input = document.querySelector('#_a-bid-input');
    var raw = input ? input.value.replace(/[^0-9.]/g, '') : '';
    var amt = raw ? '$' + parseFloat(raw).toLocaleString('en-US', {minimumFractionDigits: 0}) : '$—';
    body.innerHTML = '<span class="mwy-confirm-label">You are bidding</span>' +
                     '<span class="mwy-confirm-amount">' + amt + '</span>';
  }

  new MutationObserver(function() {
    if (!modal.classList.contains('_a-hidden-menu')) {
      updateBody();
    }
  }).observe(modal, { attributes: true, attributeFilter: ['class'] });
})();


// ── AP-ready init guard — ensures observers attach after AP elements exist ─────────
(function() {

  function runAPInit() {
    var errDiv  = document.getElementById('_a-error-message');
    var errSpan = document.getElementById('_a-error-message-span');
    var modal   = document.getElementById('_a-auction-modal-bid-confirm');
    if (!errDiv || !errSpan || !modal) return false;

    // Guard: only wire up once per element lifecycle
    if (errDiv._mwyInit) return true;
    errDiv._mwyInit = true;

    function getOrCreateNotice() {
      var el = document.querySelector('.mwy-notice');
      if (el) return el;
      el = document.createElement('div');
      el.className = 'mwy-notice';
      var hint = document.querySelector('#_a-auction-inputs-container .mwy-bid-hint');
      if (hint && hint.parentElement) hint.parentElement.insertBefore(el, hint.nextSibling);
      return el;
    }

    function showNotice(html, type) {
      if (!html || !html.trim()) return;
      var el = getOrCreateNotice();
      if (el._fadeTimer) clearTimeout(el._fadeTimer);
      el.innerHTML = html;
      el.classList.remove('mwy-notice--error', 'mwy-notice--success');
      el.classList.add(type === 'success' ? 'mwy-notice--success' : 'mwy-notice--error');
      el.style.opacity = '1';
      el.style.display = 'block';
      el._fadeTimer = setTimeout(function() {
        el.style.opacity = '0';
        setTimeout(function() {
          el.style.display = 'none';
          el.style.opacity = '1';
          el._fadeTimer = null;
        }, 850);
      }, 10000);
    }

    // Error message observer
    new MutationObserver(function() {
      if (!errDiv.classList.contains('_a-hide') && !errDiv.classList.contains('_a-display-none')) {
        var html = errSpan.innerHTML.trim();
        errDiv.classList.add('_a-hide');
        if (/must\s+(log\s*in|login)|login\s+or\s+create/i.test(html)) {
          html = '<a href="/account/login">Log in<\/a> to place a bid';
        }
        showNotice(html, 'error');
      }
    }).observe(errDiv, { attributes: true, attributeFilter: ['class'] });

    // Banner observers
    var bannerTypes = {
      '_a-banner-div': 'success',
      '_a-banner-div-notification': 'success',
      '_a-banner-div-notification-outbid': 'error',
      '_a-banner-div-notification-alt': 'success'
    };
    Object.keys(bannerTypes).forEach(function(id) {
      var banner = document.getElementById(id);
      if (!banner) return;
      var bType = bannerTypes[id];
      new MutationObserver(function() {
        if (!banner.classList.contains('_a-display-none')) {
          var msgEl = banner.querySelector('._a-banner-message, ._a-banner-text-notification');
          var html = msgEl ? msgEl.innerHTML.trim() : '';
          banner.classList.add('_a-display-none');
          if (html) showNotice(html, bType);
        }
      }).observe(banner, { attributes: true, attributeFilter: ['class'] });
    });

    // Confirm modal: inject bid amount before display
    var body = modal.querySelector('._a-modal-body');
    if (body) {
      function updateBody() {
        var input = document.getElementById('_a-bid-input');
        var raw = input ? input.value.replace(/[^0-9.]/g, '') : '';
        var amt = raw ? '$' + parseFloat(raw).toLocaleString('en-US', {minimumFractionDigits: 0}) : '$—';
        body.innerHTML = '<span class="mwy-confirm-label">You are bidding<\/span>' +
                         '<span class="mwy-confirm-amount">' + amt + '<\/span>';
      }
      new MutationObserver(function() {
        if (!modal.classList.contains('_a-hidden-menu')) updateBody();
      }).observe(modal, { attributes: true, attributeFilter: ['class'] });
    }

    return true;
  }

  // Try immediately — AP may already be loaded on a warm page
  if (!runAPInit()) {
    var _mwyPoll = setInterval(function() {
      if (runAPInit()) clearInterval(_mwyPoll);
    }, 200);
    setTimeout(function() { clearInterval(_mwyPoll); }, 15000);
  }

})();


/* ============================================
   STORE MENU — toggle .menu-open on parent
   ============================================ */
(function() {
  var wrapper = document.querySelector('.store-menu-mobile');
  if (!wrapper) return;
  var observer = new MutationObserver(function() {
    var dropdown = wrapper.querySelector('.dropdown-menu');
    if (dropdown && dropdown.classList.contains('is-open')) {
      wrapper.classList.add('menu-open');
    } else {
      wrapper.classList.remove('menu-open');
    }
  });
  var dropdown = wrapper.querySelector('.dropdown-menu');
  if (dropdown) {
    observer.observe(dropdown, { attributes: true, attributeFilter: ['class'] });
  }
})();
